import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { Loading, RichTextEditor } from "components";
import { Form, Modal, Input, notification } from "antd";

import {
  campaignTemplateEditClose,
  campaignTemplateEditSave,
  reset,
} from "./redux/slice";

const EditCampaignTemplateModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const [form] = Form.useForm();

  const [id, setId] = useState();
  const { loading, isOpen, data, result, error } = useSelector(
    (state) => state.editTemplateRedux
  );

  const companyParameters = [
    { key: "company_id", field: "id" },
    { key: "company_name", field: "name" },
    { key: "company_email", field: "email" },
    { key: "company_username", field: "username" },
    { key: "company_login", field: "login" },
  ]

  //Verificacion de carga
  useEffect(() => {
    if (data && !id) {
      //se carga la info al form solo una vez
      setId(data.id);
      //se especifica la carga de los valores al form
      form.setFieldsValue({
        ...data,
      });
    }

    if (result) {
      dispatch(reset({ result: null }));
      notification.success({ message: messages["saveSuccessfully"] }); //, description: messages["saveSuccessfully"] })
      closeModal(true);
    }

    if (error) {
      dispatch(reset({ error: null }));
      notification.error({
        message: messages["saveError"],
        description: messages[error] || error,
      });
    }
  }, [data, result, error]);

  //se valida y se limpia todo lo que pueda causar errores
  const closeModal = useCallback((refresh) => {
    setId();
    form.resetFields();
    dispatch(campaignTemplateEditClose());
    onClose && onClose(refresh);
  });
  return (
    <div>
      <Modal
        open={isOpen}
        width={1500}
        onCancel={() => closeModal()}
        footer={null}
        maskClosable={false}
      >
        <div className="p-3 p-md-5">
          <div className="text-center mb-4">
            <h3>
              {id
                ? messages["parameters_editTemplate_edit"]
                : messages["parameters_editTemplate_create"]}
            </h3>
          </div>

          <Loading loading={loading}>
            <div className="card-body">
              <Form
                form={form}
                layout="vertical"
                onFinish={(values) => {
                  dispatch(
                    campaignTemplateEditSave({
                      id: id,
                      ...values,
                    })
                  );
                }}
              >
                <div className="row g-3">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <Form.Item
                          name="name"
                          label={
                            <label className="form-label">
                              {messages["parameters_editTemplate_name"]}
                            </label>
                          }
                          rules={[
                            {
                              required: true,
                              message: messages["required_field"],
                            },
                          ]}
                        >
                          <Input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" />
                        </Form.Item>
                      </div>
                      <div className="col-12 col-md-6">
                        <Form.Item
                          name="subject"
                          label={
                            <label className="form-label">
                              {messages["parameters_editTemplate_subject"]}
                            </label>
                          }
                        /* rules={[
                          {
                            required: true,
                            message: messages["required_field"],
                          },
                        ]} */
                        >
                          <Input className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      {messages["parameters_companyParameters"]}
                    </label>
                    <p>
                      {
                        //console.log("data", data, JSON.stringify([{ key: "nome", field: "nome" }]))
                        companyParameters &&
                        companyParameters.map((x) => x.key).join(", ")
                      }
                    </p>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      {messages["parameters_parameters"]}
                    </label>
                    <p>
                      {
                        //console.log("data", data, JSON.stringify([{ key: "nome", field: "nome" }]))
                        data?.parameters &&
                        JSON.parse(data.parameters)
                          .map((x) => x.key)
                          .join(", ")
                      }
                    </p>
                  </div>
                  <div className="col-12">
                    <Form.Item
                      name="body"
                      label={
                        <label className="form-label">
                          {messages["parameters_editTemplate_body"]}
                        </label>
                      }
                      rules={[
                        { required: true, message: messages["required_field"] },
                      ]}
                    >
                      <RichTextEditor height="calc(100vh - 280px)" />
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </Loading>

          <div className="row pt-5">
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary me-sm-3 me-1"
                onClick={() => form.submit()}
              >
                {messages["save"]}
              </button>
              <button
                type="button"
                className="btn btn-label-secondary"
                onClick={() => closeModal()}
              >
                {messages["cancel"]}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditCampaignTemplateModal;
